// src/common/TopStyle.js
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import { Button, DialogTitle, IconButton, TableCell } from '@mui/material';
import { AppStyle, AppWord } from '../value/AppConst';

export const TopContainer = styled(Box)({
    flexGrow:1,
    display:'flex', flexDirection:'column'
});

export const TopHeader = styled(Box)({
    display:'flex', alignItems:'center', padding: '0.5rem', boxSizing: 'border-box',
    borderBottom: '1px solid #aaa', backgroundColor:'#f7f7f7',
    color: AppStyle.PrimaryRGB, fontWeight: 'bold',
});

export const ControlLine = styled(Box)({
    display:'flex', alignItems:'center', padding: '0.5rem', boxSizing: 'border-box',
});

export const TopContent = styled(Box)({
    flexGrow:1, padding:'0.5rem', overflowY:'auto', // border: '3px solid red',
    boxSizing: 'border-box',
});

export const LabelCell = styled(TableCell)({fontSize: '0.8rem', color: '#555', });
export const NumberCell = styled(TableCell)({textAlign: 'right', paddingRight: '1rem'});
export const CenterCell = styled(TableCell)({textAlign: 'center'});
export const InputTableCell = styled(TableCell)({
    padding: 1
});


export const NonCapButton = styled(Button)({
    textTransform: 'none !important',
});

export const ViewerCloserBox = ({
    onClick,
    color,
}) => <Box style={{textAlign:'center', display:'flex', justifyContent:'center', }}>
    <Box style={{
        padding: '0.2rem', backgroundColor: '#ddd', // borderRadius: '0.5rem',
        borderBottomLeftRadius: '1rem', borderBottomRightRadius: '1rem',
    }}>
        <IconButton onClick={onClick} color={color || AppStyle.mui.success}>
            <HighlightOffIcon fontSize={AppWord.LARGE}/>
        </IconButton>
    </Box>
</Box>;

export const ViewerHeader = ({title, onClickClose}) => {
    return(
        <TopHeader
            style={{fontSize: '1.05rem', fontWeight: 'bold'}}
        >
            <Box style={{flexGrow:1}}>{title}</Box>
            <IconButton onClick={onClickClose}>
                <CloseIcon fontSize={AppWord.LARGE}/>
            </IconButton>
        </TopHeader>
    )
};

export const NoDataBox = ({title='조회된 데이터가 없습니다.'}) => {
    return(
        <Box
            style={{
                display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%',
            }}
        >
            <Box
                style={{
                    textAlign: 'center',
                    display: 'inline-block'
                }}
            >
                <LocalCafeIcon fontSize={AppWord.LARGE}
                    color={AppStyle.mui.success}
                />
                <Box
                    style={{
                        color: AppStyle.SuccessRGB, fontSize: '1.05rem', marginTop: '2rem'
                    }}
                >{title}</Box>
            </Box>
        </Box>
    )
};

export const DialogHeader = ({title, onClickClose}) => {
    return(
        <DialogTitle
            style={{
                backgroundColor: AppStyle.SecondaryRGB, color: 'white', fontWeight: 'bold',
                display: 'flex', alignItems: 'center'
            }}
        >
                <span style={{flexGrow:1}}>{title}</span>
                <IconButton onClick={onClickClose}>
                    <CloseIcon style={{color: 'white'}}/>
                </IconButton>
        </DialogTitle>
);
};